
import { Link } from 'react-router-dom';
import { useEffect } from 'react';

export default function Impressum() {
  useEffect(() => {
    // SEO Meta Tags für Impressum
    document.title = 'Impressum - IPSAS EPSAS Deutschland';
    
    // Meta Description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Impressum der IPSAS-EPSAS Deutschland Plattform. Angaben gemäß § 5 TMG, Kontaktdaten und rechtliche Informationen für Public Sector Accounting Standards.');
    }
    
    // Meta Keywords
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'Impressum, IPSAS-EPSAS, Thomas Hück, Berlin, Kontakt');
    }
    
    // Canonical URL
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', `${import.meta.env.VITE_SITE_URL}/impressum`);
    }
    
    // Last Modified
    const lastModified = document.querySelector('meta[http-equiv="last-modified"]');
    if (lastModified) {
      lastModified.setAttribute('content', new Date().toISOString().split('T')[0]);
    }
    
    // Schema.org JSON-LD für Impressum
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "Impressum",
      "url": `${import.meta.env.VITE_SITE_URL}/impressum`,
      "description": "Impressum der IPSAS-EPSAS Deutschland Plattform",
      "mainEntity": {
        "@type": "Organization",
        "name": "IPSAS-EPSAS Deutschland",
        "founder": {
          "@type": "Person",
          "name": "Thomas Hück"
        },
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Schröderstr. 3",
          "postalCode": "10115",
          "addressLocality": "Berlin",
          "addressCountry": "DE"
        },
        "contactPoint": {
          "@type": "ContactPoint",
          "telephone": "+49-1579-2501421",
          "email": "impressum@ipsas-epsas.de",
          "contactType": "customer service"
        }
      }
    });
    document.head.appendChild(script);
    
    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            <div className="flex items-center">
              <Link to="/">
                <h1 className="text-2xl font-bold text-blue-900" style={{ fontFamily: '"Pacifico", serif' }}>
                  IPSAS-EPSAS
                </h1>
              </Link>
            </div>
            <div className="flex items-center gap-4">
              <Link 
                to="/login" 
                className="px-6 py-2.5 bg-blue-900 text-white font-semibold rounded-lg hover:bg-blue-800 transition-colors whitespace-nowrap cursor-pointer"
              >
                Mitglieder-Login
              </Link>
            </div>
          </div>
        </div>
      </nav>

      {/* Main Content */}
      <main className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white">
            <h1 className="text-4xl font-bold text-gray-900 mb-8">Impressum</h1>
            
            <div className="prose prose-lg max-w-none">
              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">Angaben gemäß § 5 TMG</h2>
                <div className="text-gray-700 leading-relaxed">
                  <p className="mb-2"><strong>Thomas Hück</strong></p>
                  <p className="mb-2">Schröderstr. 3</p>
                  <p className="mb-4">10115 Berlin</p>
                </div>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">Kontakt</h2>
                <div className="text-gray-700 leading-relaxed">
                  <p className="mb-2">
                    <strong>Telefon:</strong> 
                    <a href="tel:+4915792501421" className="text-blue-600 hover:text-blue-800 ml-2">
                      +49 1579-2501421
                    </a>
                  </p>
                  <p className="mb-2"><strong>Telefax:</strong> 02486/800520</p>
                  <p className="mb-4">
                    <strong>E-Mail:</strong> 
                    <a href="mailto:impressum@ipsas-epsas.de" className="text-blue-600 hover:text-blue-800 ml-2">
                      impressum@ipsas-epsas.de
                    </a>
                  </p>
                </div>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">Postadresse</h2>
                <div className="text-gray-700 leading-relaxed">
                  <p className="mb-2"><strong>Thomas Hück</strong></p>
                  <p className="mb-2">Postbox 611441</p>
                  <p className="mb-4">96035 Bamberg</p>
                </div>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">Redaktionell verantwortlich</h2>
                <div className="text-gray-700 leading-relaxed">
                  <p className="mb-2"><strong>Thomas Hück</strong></p>
                  <p className="mb-2">Schröderstr. 3</p>
                  <p className="mb-4">10115 Berlin</p>
                </div>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">EU-Streitschlichtung</h2>
                <div className="text-gray-700 leading-relaxed">
                  <p className="mb-4">
                    Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: 
                    <a 
                      href="https://ec.europa.eu/consumers/odr/" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-blue-600 hover:text-blue-800 ml-1"
                    >
                      https://ec.europa.eu/consumers/odr/
                    </a>.
                  </p>
                  <p>Unsere E-Mail-Adresse finden Sie oben im Impressum.</p>
                </div>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">Verbraucherstreitbeilegung/Universalschlichtungsstelle</h2>
                <div className="text-gray-700 leading-relaxed">
                  <p>
                    Wir nehmen an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teil. 
                    Zuständig ist die Universalschlichtungsstelle des Zentrums für Schlichtung e.V., 
                    Straßburger Straße 8, 77694 Kehl am Rhein (
                    <a 
                      href="https://www.verbraucher-schlichter.de" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-blue-600 hover:text-blue-800"
                    >
                      https://www.verbraucher-schlichter.de
                    </a>
                    ).
                  </p>
                </div>
              </section>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-gray-900 text-gray-300 py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8 mb-8">
            <div>
              <h5 className="text-white font-bold text-lg mb-4">IPSAS-EPSAS</h5>
              <p className="text-sm leading-relaxed">
                Ihre zentrale Plattform für internationale und europäische 
                Standards der öffentlichen Rechnungslegung
              </p>
            </div>

            <div>
              <h5 className="text-white font-bold text-lg mb-4">Plattform</h5>
              <ul className="space-y-2 text-sm">
                <li>
                  <a 
                    href="mailto:registration@ipsas-epsas.de?subject=Registrierungsanfrage"
                    className="hover:text-white transition-colors cursor-pointer"
                  >
                    Registrierung
                  </a>
                </li>
                <li>
                  <Link to="/login" className="hover:text-white transition-colors cursor-pointer">
                    Login
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h5 className="text-white font-bold text-lg mb-4">Ressourcen</h5>
              <ul className="space-y-2 text-sm">
                <li>
                  <Link to="/login" className="hover:text-white transition-colors cursor-pointer">
                    IPSAS Standards
                  </Link>
                </li>
                <li>
                  <Link to="/login" className="hover:text-white transition-colors cursor-pointer">
                    EPSAS Standards
                  </Link>
                </li>
                <li>
                  <Link to="/login" className="hover:text-white transition-colors cursor-pointer">
                    Public Sector Accounting
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h5 className="text-white font-bold text-lg mb-4">Kontakt</h5>
              <ul className="space-y-2 text-sm">
                <li>
                  <Link to="/impressum" className="hover:text-white transition-colors cursor-pointer">
                    Impressum
                  </Link>
                </li>
                <li>
                  <Link to="/login" className="hover:text-white transition-colors cursor-pointer">
                    Datenschutz
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center text-sm">
            <p>&copy; 2024 IPSAS-EPSAS.de. Alle Rechte vorbehalten.</p>
            <a 
              href="https://readdy.ai/?origin=logo" 
              className="text-gray-400 hover:text-white transition-colors cursor-pointer mt-4 md:mt-0"
            >
              Website Builder
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}
